import React from "react";
import './style.scss'

export default function Contact() {

  return <div className="contact-box">
    <div className="page-contact">
      <div className="contact-title">Contact</div>
      <div className="contact-con">
        Please contact Yinpeng Dong (dyp17@mails.tsinghua.edu.cn), Tianyu Pang (pty17@mails.tsinghua.edu.cn), Xiao Yang (yangxiao19@mails.tsinghua.edu.cn)
        if you have any questions.
      </div>
    </div>
  </div>
}
